import logo from "./logo.svg";
import "./App.css";
import VoiceTutorRecorder from "./pages/audio";
function App() {
  return (
    <div className="App">
      <VoiceTutorRecorder />
    </div>
  );
}

export default App;
